import type { VinDetail } from '@/api/schemas';
import { Separator } from '@/components/ui/separator';
import { NOT_AVAILABLE, orNotAvailable } from '@/lib/display';
import { DateText } from '@/lib/formatDate';

function makeModelFamilySeries(detail: VinDetail | null): string {
  if (!detail) {
    return NOT_AVAILABLE;
  }

  return (
    [detail.make, detail.modelFamily, detail.series]
      .filter(Boolean)
      .join(' ') || NOT_AVAILABLE
  );
}

function IdentitySeparator() {
  return <Separator orientation="vertical" className="h-4 bg-separator" />;
}

export function VehicleIdentityRow({
  detail,
  compact = false,
}: {
  detail: VinDetail | null;
  compact?: boolean;
}) {
  return (
    <div
      className={`flex flex-wrap items-center ${compact ? 'gap-2 text-[14px] leading-5' : 'gap-4 text-[16px] leading-5'}`}
    >
      <span className="font-normal text-black">
        {makeModelFamilySeries(detail)}
      </span>
      <IdentitySeparator />
      <span className="font-medium text-[var(--intl-accent)]">
        {orNotAvailable(detail?.customerName)}
      </span>
      <IdentitySeparator />
      <span className="font-normal text-black">
        {orNotAvailable(detail?.modelYear)}
      </span>
      <IdentitySeparator />
      <span className="flex items-center gap-2">
        <span className="font-normal text-black">DTU</span>
        <span className="font-medium text-black">
          {detail?.deliveryDate ? (
            <DateText value={detail.deliveryDate} />
          ) : (
            NOT_AVAILABLE
          )}
        </span>
      </span>
    </div>
  );
}
